import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
    return (
        <footer id="contact" style={{ background: "#222", color: "#fff", padding: "20px 0" }}>
            <Container fluid>
                {/* <Row className="text-center text-md-start">
                    <Col md={6}>
                        <h5 className="fw-bold">GT SOFTWARE ACADEMY</h5>
                        <p>
                            No.336/2, Ground Floor, <br />
                            Mayflower Valencia, Nava India, Peelamedu,<br />
                            <br />
                            India
                        </p>
                    </Col>
                    <Col md={6} className="text-md-end">
                        <p>
                            📞 <strong>+91 8667390454</strong> <br />
                        </p>
                    </Col>
                </Row>
                <hr style={{ borderColor: "rgba(255,255,255,0.2)" }} /> */}
                <Row>
                    <Col className="text-center">
                        <p style={{ margin: 0 }}>
                            GT SOFTWARE ACADEMY &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;📍​​ No.336/2, Ground Floor, Mayflower Valencia, Nava India
                            Coimbatore, Tamil Nadu - 641004 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;📞 <strong>+91 8667390454</strong>
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
